import { CollapsibleContainer } from 'components/common'
import React, { useEffect, useState } from 'react'
import _debounce from 'lodash.debounce'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'
import './styles.scss'
import { apiInchat } from 'api'
import { IMAGE_FORMATS } from 'constants/unsupportedFileFormats'
import { getFormatedDate } from 'utils'
import { SelectWithLabel } from 'components/Form'
import { orderFilesInchat, typeFilesInchat } from 'constants/inchatConstant'
import TextInputField from 'components/Form/TextInputField'
import { toastMessage } from 'utils/messages'
import NotResult from 'components/common/NotResult'
import { useDispatch } from 'react-redux'
import inchatActions from 'redux/inchat/actions'

const PluginSharedFiles = (props) => {
  const {
    id,
    conversationId,
    isThread
  } = props

  const [isLoading, setIsLoading] = useState(false)
  const [openPlugin, setOpenPlugin] = useState(false)
  const [dataFiles, setDataFiles] = useState([])
  const [openFilter, setOpenFilter] = useState(false)
  const [openSearch, setOpenSearch] = useState(false)
  const [filters, setFilters] = useState({
    orderFilter: { value: 'asc', label: lang('dashboard_order_asc') },
    typeFilter: { value: '', label: lang('dashboard_all') },
    name: ''
  })

  const dispatch = useDispatch()

  useEffect(() => {
    if(conversationId) getDataPlugins()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId])

  useEffect(() => {
    const debouncedSearchChannel = _debounce((inputSearch, typeFilter, orderFilter) => {
      getDataPlugins(inputSearch, typeFilter, orderFilter)
    }, 300)
    if(openPlugin && !isLoading){
      debouncedSearchChannel(filters)
    }
    return () => {
      debouncedSearchChannel.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, openPlugin])

  const handleCollapsible = () => {
    setOpenPlugin(state => !state)
    if(openSearch || openFilter){
      setOpenSearch(false)
      setOpenFilter(false)
    }
  }

  const getDataPlugins = async () => {
    setIsLoading(true)
    try {
      const { orderFilter, typeFilter, name } = filters
      let body = {
        conversationId,
        orderFilter: orderFilter.value
      }
      if(name) body.name = name
      if(typeFilter.value) body.typeFilter = typeFilter.value
      const { data: { data } } = await apiInchat.getFilesConversation(body)
      setDataFiles(data)
    } catch (error) {
      toastMessage(lang('dashboard_shared_files_error_get'), 'error')
    }
    setIsLoading(false)
  }

  const handleSelectOption = (type='filter') => {
    if(!openPlugin) handleCollapsible()
    if(type === 'filter'){
      setOpenSearch(false)
      setOpenFilter(state => !state)
      return
    }
    setOpenSearch(state => !state)
    setOpenFilter(false)
    return
  }

  const handleChangeSelectors = (type, value) => {
    setFilters(prevState => {
      return {
        ...prevState,
        [type]: value
      }
    })
  }

  const handlePressTitle = (file) => {
    const newFile = { ...file }
    delete newFile.__v
    delete newFile.createdAt
    delete newFile.updatedAt
    dispatch(inchatActions.editMessageAddAttachments(conversationId, [newFile], isThread))
  }

  return (
    <div className='inchat-plugin-files'>
      <CollapsibleContainer
        isOpen={openPlugin}
        toggle={handleCollapsible}
        height={300}
        isLoading={isLoading}
        title={`${lang(`${id}_plugin_title`)} ${dataFiles.length ? `(${dataFiles.length})`: ''}`}
        id={id}
        icon={
          <img
            src={getStaticImage(`/icons/orange-brand/icon-${id === 'shared_files' ? 'file-dark' : 'book-open-dark'}.svg`)}
            alt={id}
          />
        }
        theme={'dark'}
        className={'inchat-plugin-files__container'}
        optionsComponent={
          <div className='inchat-plugin-files__buttons-container'>
            <i
              className={`fa fa-filter ${openFilter ? 'open' : ''}`}
              onClick={() => handleSelectOption()}
            />
            <i
              className={`fa fa-search ${openSearch ? 'open' : ''}`}
              onClick={() => handleSelectOption('search')}
            />
            <i
              className={`fa fa-chevron-${openPlugin ? 'up' : 'down'}`}
              onClick={handleCollapsible}
            />
          </div>
        }
      >
        <>
          {openFilter || openSearch ?
            <div className='inchat-plugin-files__header'>
              {openFilter &&
                <div className='inchat-plugin-files__header--selector'>
                  <SelectWithLabel
                    classNameWrapper='inchat-plugin-files__selectors'
                    options={typeFilesInchat.map(type => ({
                      ...type,
                      label: lang(type.label)
                    }))}
                    value={filters.typeFilter}
                    onChange={(value) => handleChangeSelectors('typeFilter', value)}
                    placeholder={lang('dashboard_type')}
                    labelCustomSelected={lang('dashboard_types')}
                    isRequiredAll
                  />
                  <SelectWithLabel
                    classNameWrapper=' inchat-plugin-files__selectors inchat-plugin-files__selectors--order'
                    options={orderFilesInchat.map(order => ({
                      ...order,
                      label: lang(`dashboard_order_${order.label}`)
                    }))}
                    value={filters.orderFilter}
                    onChange={(value) => handleChangeSelectors('orderFilter', value)}
                    placeholder={lang('order_by')}
                  />
                </div>
              }
              {openSearch && <TextInputField
                classNameWrapper='text-search-files'
                name={'search_files'}
                placeholder={`${lang('dashboard_search')}...`}
                value={filters.name}
                onChange={(value) => handleChangeSelectors('name', value)}
                className={'icon-search-channel'}
              />}
            </div> : null
          }
          <div className='inchat-plugin-files__list'>
            {!isLoading && !dataFiles.length && <NotResult message={lang('dashboard_no_results_found')} />}
            {dataFiles.map(file => {
              return (
                <div
                  key={file._id}
                  className='inchat-plugin-files__list--card'
                  title={file.filename}
                >
                  <div
                    className='inchat-plugin-files__list--card-name'
                  >
                    <div
                      className='inchat-plugin-files__list--card-icon'
                      onClick={() => window.open(file.urlLong, "_blank")}
                    >

                      {file.mimeType === 'image' && !IMAGE_FORMATS.includes((file?.mimeSubtype || ''))
                        ? <img src={file.urlLong} alt='imagePreview'/>
                        : <i className={'fa fa-file-o'} />
                      }
                    </div>
                    <span onClick={() => handlePressTitle(file)} className='text-ellipsis'>{file.filename}</span>
                  </div>
                  <span className='inchat-plugin-files__list--card-date'>{getFormatedDate({ isoString: file.createdAt, withTime: false, withYear: true } )}</span>
                </div>
              )
            })}
          </div>
        </>
      </CollapsibleContainer>
    </div>
  )
}

export default PluginSharedFiles